import { render, staticRenderFns } from "./NewsListTwo.vue?vue&type=template&id=dc52d18a"
import script from "./NewsListTwo.vue?vue&type=script&lang=js"
export * from "./NewsListTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsListTwo.vue?vue&type=style&index=0&id=dc52d18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports